import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OffersTableColumnConfig, OffersTableSortState} from '../../../../../../core/services/impl/offers-table.service';
import {SortOrder} from '../../../../../enums/sort-order.enum';
import {AssetsService} from '../../../../../services/assets.service';

@Component({
  selector: 'app-offers-table-header-cell',
  templateUrl: './offers-table-header-cell.component.html',
  styleUrls: []
})
export class OffersTableHeaderCellComponent implements OnInit {

  @Input() config: OffersTableColumnConfig;
  @Input() sortActive: boolean = false;
  @Input() sortOrder: SortOrder = SortOrder.DESCENDING;

  @Output() sortUpdate: EventEmitter<OffersTableSortState> = new EventEmitter<OffersTableSortState>();

  sortActiveIcon: string;
  sortInactiveIcon: string;

  constructor(private assetsService: AssetsService) { }

  ngOnInit() {
    this.initIcons();
  }

  updateSort(): void {
    this.sortUpdate.emit({
      key: this.config.key,
      order: this.sortActive ? this.getOppositeSortOrder() : this.sortOrder
    })
  }

  private getOppositeSortOrder(): SortOrder {
    return this.sortOrder === SortOrder.ASCENDING ? SortOrder.DESCENDING : SortOrder.ASCENDING;
  }

  private initIcons(): void {
    this.sortActiveIcon = `${this.assetsService.getIconsDirectoryPath()}/offers-table-header-cell-sort-active.svg`;
    this.sortInactiveIcon = './assets/images/icons/offers-table-header-cell-sort-inactive.svg';
  }

}
